export enum CrossPlay {
  windowsStoreVersions = "windowsStoreVersions",
  win32Versions = "win32Versions",
  playStationVersions = "playStationVersions",
  nintendoSwitchVersions = "nintendoSwitchVersions",
  otherVersions = "otherVersions",
}
